<zah-clienten-overzicht-therapeut [initialPageRequest]="initialPageRequest"
                                  [clientenPage]="clientenPage$ | async"
                                  (clientClicked)="navigateToClient($event)"
                                  (pageChange)="onPageChange($event)">
</zah-clienten-overzicht-therapeut>
